import React, {useEffect, useRef, useState} from 'react';
import {useDispatch} from "react-redux";
import MindsetsJsSDK, {
    CustomDropdown,
    datesConstants,
    ErrorMessageAction,
    InlineEdit,
    LoadingAction
} from "mindsets-js-sdk";

export default function () {
    const dispatch = useDispatch();
    const fileUploadRef = useRef(null);

    const [model, setModel] = useState('us.meta.llama3-3-70b-instruct-v1:0');
    const [message, setMessage] = useState(getEmptyMessage());
    const [messages, setMessages] = useState([]);
    const [chats, setChats] = useState([]);
    const [chat_id, setChatId] = useState(null);

    let chat = null;
    if (chat_id) {
        const index = chats.findIndex(chat => chat.id === chat_id);
        if (index >= 0) {
            chat = chats[index];
        }
    }

    useEffect(() => {
        loadChats();
    }, []);

    function loadChats() {
        return MindsetsJsSDK().API.get('ai/chats').then(response => {
            setChats(response.items);

            return response.items;
        });
    }

    function getEmptyMessage() {
        return {role: 'user', content: [{text: ''}]};
    }

    function renderText(content_item, index) {
        return (
            <div key={index} dangerouslySetInnerHTML={{__html: content_item.text.replaceAll("\n", "<br/>")}}/>
        );
    }

    function renderImage(content_item, index) {
        return (
            <img
                key={index}
                src={content_item.image.source.s3Location ? content_item.image.source.s3Location.uri : btoa(content_item.image.source.bytes)}
                alt=''
                style={{
                    maxHeight: '170px'
                }}
            />
        );
    }

    function renderContentItem(content_item, index) {
        if (content_item.text) {
            return renderText(content_item, index);
        } else if (content_item.image) {
            return renderImage(content_item, index);
        }

        return (
            <div>Error</div>
        );
    }

    function renderMessageContent(message) {
        if (message.role === 'user') {
            return (
                <>
                    <div className='d-flex flex-column'>
                        {message.content.map(renderContentItem)}
                    </div>
                    <i className="fas fa-2x fa-user"/>
                </>
            );
        } else {
            return (
                <>
                    <i className="fas fa-2x fa-robot"/>
                    <div className='d-flex flex-column'>
                        {message.content.map(renderContentItem)}
                    </div>
                </>
            );
        }
    }

    function renderMessage(message, index) {
        const date = new Date(message.timestamp);

        return (
            <div key={index} className={'d-flex justify-content-' + (message.role === 'user' ? 'end' : 'start')}>
                <div className={'d-flex flex-column align-items-' + (message.role === 'user' ? 'end' : 'start')}>
                    <div className='d-flex bordered p-2 flex-gap-10 align-items-center"'>
                        {renderMessageContent(message)}
                    </div>
                    <label>{date.toLocaleDateString('en-US', {
                        month: 'long',
                        year: 'numeric',
                        day: 'numeric',
                        'hour': '2-digit',
                        'minute': '2-digit'
                    })}</label>
                </div>
            </div>
        );
    }

    function renderThread() {
        return (
            <div className='my-2 d-flex flex-column flex-gap-10'>
                {messages.map(renderMessage)}
            </div>
        );
    }

    function renderUploadedImagePreview() {
        const image_item_index = message.content.findIndex(i => 'image' in i);
        if (image_item_index >= 0) {
            return (
                <div style={{
                    position: 'absolute',
                    right: '10px',
                    bottom: '10px'
                }}>
                    <div style={{position: 'relative'}}>
                        <img
                            style={{height: '50px'}}
                            src={message.content[image_item_index].image.source.bytes}
                            alt=''
                            onClick={() => {
                                const message_new = JSON.parse(JSON.stringify(message));
                                message_new.content.splice(image_item_index, 1);
                                setMessage(message_new);
                            }}
                        />
                        <i
                            className='fas fa-times-circle'
                            style={{
                                position: 'absolute',
                                top: '-9px',
                                right: '-9px',
                                fontSize: '22px',
                                color: 'red',
                                cursor: 'pointer'
                            }}
                            onClick={() => {
                                const message_new = JSON.parse(JSON.stringify(message));
                                message_new.content.splice(image_item_index, 1);
                                setMessage(message_new);
                            }}
                        />
                    </div>
                </div>
            );
        }

        return null;
    }

    function renderImageUploadButton() {
        const image_item = message.content.filter(i => 'image' in i)[0];
        if (!image_item) {
            return (
                <>
                    <input
                        type="file"
                        accept="image/*"
                        hidden={true}
                        ref={fileUploadRef}
                        onChange={() => {
                            const file = fileUploadRef.current.files[0];
                            const format = file.name.split('.').pop();
                            const reader = new FileReader();
                            reader.onload = function (e) {
                                const bytes = e.target.result;
                                console.log('bytes: ', bytes)
                                const base64 = bytes.toString("base64");
                                // const imageBuffer = new Uint8Array(fs.readFileSync("./butterfly.png").buffer)

                                const message_new = JSON.parse(JSON.stringify(message));
                                const image_message_item_index = message_new.content.findIndex(i => 'image' in i);
                                if (image_message_item_index >= 0) {
                                    message_new.content[image_message_item_index].image.source.bytes = base64;
                                } else {
                                    message_new.content.push({image: {format, source: {bytes: base64}}});
                                }
                                setMessage(message_new);
                            };
                            // reader.readAsDataURL(file);
                            reader.readAsArrayBuffer(file);
                        }}
                    />
                    <button
                        style={{
                            position: 'absolute',
                            bottom: "10px",
                            right: "10px"
                        }}
                        onClick={event => {
                            event.preventDefault();
                            fileUploadRef.current.click();
                        }}
                    >
                        <i className='fas fa-image'/>
                    </button>
                </>
            );
        }

        return null;
    }

    function submit() {
        const messages_new = JSON.parse(JSON.stringify(messages));
        const message_new = JSON.parse(JSON.stringify(message));
        message_new.timestamp = Date.now();
        messages_new.push(message_new);
        setMessages(messages_new);
        setMessage(getEmptyMessage());

        dispatch(LoadingAction(true, 'Loading...'));
        MindsetsJsSDK().API
            .post('ai/ask', {model, message: message_new, chat_id})
            .then(response => {
                const messages_new_new = JSON.parse(JSON.stringify(messages_new));
                messages_new_new.push(response.message);
                setMessages(messages_new_new);
                if (!chat_id || chat_id !== response.chat_id) {
                    loadChats().then(() => {
                        setChatId(response.chat_id);
                    });
                }
            })
            .catch(error => {
                console.error(error);
                dispatch(ErrorMessageAction(error, true));
                const last_message = messages_new.pop();
                setMessages(messages_new);
                setMessage(last_message);
            })
            .finally(() => dispatch(LoadingAction(false)));
    }

    function deleteChat(chat_id_to_delete) {
        MindsetsJsSDK().API.delete('ai/chats/' + chat_id_to_delete).then(() => {
            loadChats().then(() => {
                if (chat_id_to_delete === chat_id) {
                    setChatId(null);
                    setMessages([]);
                    setMessage(getEmptyMessage());
                }
            });
        })
    }

    function renderChats() {
        return (
            <div className='d-flex flex-column flex-gap-10'>
                <label>My Chats</label>
                <button
                    className='small'
                    disabled={!chat_id}
                    onClick={(event) => {
                        event.preventDefault();
                        setMessages([]);
                        setMessage(getEmptyMessage());
                        setChatId(null);
                    }}>Start a new Chat
                </button>
                <div className='d-flex flex-column flex-gap-10'>
                    {chats.map(chat => {
                        const date = new Date(chat.created_at * 1000);

                        return (
                            <div key={chat.id} className='d-flex flex-gap-5 align-items-center justify-content-between'>
                                <div
                                    className={'hoverable ' + (chat.id === chat_id ? 'selected' : 'clickable')}
                                    onClick={() => {
                                        if (chat.id !== chat_id) {
                                            MindsetsJsSDK().API
                                                .get('ai/chats/' + chat.id)
                                                .then(response => setMessages(response.messages))
                                                .then(() => setChatId(chat.id))
                                                .then(() => setModel(chat.model));
                                        }
                                    }}>
                                    <div>{chat.title}</div>
                                    <div>{date.toLocaleDateString('en-US', datesConstants.US_DATE_FORMAT)}</div>
                                </div>
                                <CustomDropdown
                                    key={chat.id}
                                    id={'chat_' + chat.id}
                                    trigger={<i className="fas fa-ellipsis-v fa-lg"/>}
                                    no_wrap={true}
                                    content_class='dropdown-to-left'
                                    items={{
                                        delete: <div className="red" onClick={() => deleteChat(chat.id)}>Delete</div>
                                    }}
                                    use_arrow={false}/>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    function updateTitle(title) {
        MindsetsJsSDK().API.put('ai/chats/' + chat_id + '/title', {title}).then(loadChats)
    }

    function renderChatTitle() {
        if (chat) {
            return (
                <div className='d-flex flex-gap-10 align-items-center'>
                    <InlineEdit
                        key={chat.id}
                        activeClassName="pam-chart-title-input"
                        text={chat.title}
                        paramName="title"
                        change={prop => updateTitle(prop.title)}
                        minLength={1}
                        maxLength={500}
                        className='pam-chart-title'
                        staticElement='h3'
                        withIcon={true}
                    />
                </div>
            );
        }

        return (
            <h3>New Chat</h3>
        );
    }

    function renderModelSelector() {
        return (
            <div className='my-2 d-flex flex-gap-10 align-items-end'>
                <div>
                    <label>Model(You can't change the model after the chat is started)</label>
                    <select
                        value={model}
                        disabled={!!chat_id}
                        onChange={event => {
                            setMessages([]);
                            setModel(event.target.value);
                        }}>
                        <option value='us.meta.llama4-maverick-17b-instruct-v1:0' title='Fine Tuning, Text summarization, Code generation, Function calling, Advanced understanding, Assistants, Chatbots'>Llama 4 Maverick 17B Instruct</option>
                        <option value='us.meta.llama4-scout-17b-instruct-v1:0' title='Fine Tuning, Text summarization, Code generation, Function calling, Advanced understanding, Assistants, Chatbots'>Llama 4 Scout 17B Instruct</option>
                        <option value='us.meta.llama3-3-70b-instruct-v1:0' title='Tool Use. Code Generation, Advanced reasoning and decision making, Steerability'>Llama 3.3 70B Instruct</option>
                        <option value='us.anthropic.claude-sonnet-4-6' title='Hybrid reasoning, adaptive thinking, efficient code generation, enhanced text generation, agentic search, efficient research, computer use, tool use, real-time support, task efficiency, text and image inputs, steering, memory'>Anthropic Claude 4.6 Sonnet</option>
                        <option value='us.anthropic.claude-opus-4-6-v1' title='Hybrid reasoning, adaptive thinking, efficient code generation, enhanced text generation, agentic search, efficient research, computer use, tool use, real-time support, task efficiency, text and image inputs, steering, memory'>Anthropic Claude 4.6 Opus</option>
                        <option value='us.anthropic.claude-haiku-4-5-20251001-v1:0' title='Hybrid reasoning, extended thinking, efficient code generation, enhanced text generation, agentic search, efficient research, computer use, tool use, real-time support, task efficiency, text and image inputs, steering, memory'>Anthropic Claude 4.5 Haiku</option>
                        <option value='google.gemma-3-12b-it' title='Text generation; Code generation; Reasoning; Question answering; Summarization; Multilingual support; Tool use'>Google Gemma 3 12B IT</option>
                        <option value='google.gemma-3-27b-it' title='Base pretrained modeling; Multimodal understanding; Reasoning; Code understanding; Long-context representation learning'>Google Gemma 3 27B PT</option>
                        <option value='google.gemma-3-4b-it' title='Text generation; Code generation; Reasoning; Question answering; Summarization; Multilingual support; Instruction following'>Google Gemma 3 4B IT</option>
                        <option value='amazon.titan-image-generator-v2:0' title='Text-to-image, Image-to-image, Background removal, Image conditioning'>Amazon Titan Image Generator G1</option>
                    </select>
                </div>
            </div>
        );
    }

    return (
        <div className='container'>
            <title>Ask AI</title>
            <h1>Ask AI</h1>

            <div className='row'>
                <div className='col-2'>
                    {renderChats()}
                </div>
                <div className='col-10'>
                    {renderChatTitle()}
                    <form onSubmit={event => {
                        event.preventDefault();
                        submit();
                    }}>
                        {renderModelSelector()}

                        {renderThread()}

                        <div className='mb-5' style={{position: 'relative'}}>
                            {/*{renderUploadedImagePreview()}*/}
                            {/*{renderImageUploadButton()}*/}
                            <textarea
                                value={message.content.filter(i => "text" in i)[0].text}
                                onChange={event => {
                                    const message_new = JSON.parse(JSON.stringify(message));
                                    message_new.content.filter(i => 'text' in i)[0].text = event.target.value;
                                    setMessage(message_new);
                                }}
                                style={{width: '100%'}}
                                rows={4}
                                onKeyDown={event => {
                                    if (event.key === 'Enter') {
                                        if (!event.shiftKey) {
                                            event.preventDefault();
                                            submit();
                                        }
                                    }
                                }}
                            />
                            <button type='submit' disabled={!message.content[0].text}>Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}